import { ShopperAgentDiscountConfigSchema } from "@redotech/redo-shopper-agent-settings-common/discount-config";
import * as z from "zod";

export const updateShopperAgentDiscount = {
  name: "updateShopperAgentDiscount" as const,
  input: z.object({
    discountConfig: ShopperAgentDiscountConfigSchema.nullable(),
    /**
     * Saved from the support settings page: goes live at once (support reads
     * only what is published) and does not turn on the Commerce Agent's own use.
     */
    fromSupportSettings: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
